// extracted by mini-css-extract-plugin
export var ldsDualRing = "spinner-module--lds-dual-ring--2pvA9";
export var small = "spinner-module--small--1lrbE";
export var dark = "spinner-module--dark--1eBO3";